import {Component, OnInit} from '@angular/core';
import {UsuariosService} from '../usuarios/usuario.service';
import {Sucursal} from '../sucursal/sucursal';
import {SucursalService} from '../sucursal/sucursal.service';
import {Empresa} from '../empresa/empresa';
import {Nodo} from '../nodo/nodo';
import {NodoService} from '../nodo/nodo.service';
import {MedicionService} from '../medicion/medicion.service';
import {Ubicacion} from '../ubicacion/ubicacion';
import {RolService} from '../rol/rol.service';
import {EmpresaService} from '../empresa/empresa.service';
import {PermisoService} from '../permiso/permiso.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../login/login.service';
import {RegAlarma} from '../regAlarma/regAlarma';
import {RegAlarmaService} from '../regAlarma/regAlarma.service';
import 'rxjs/Rx';
import {LogActividadService} from "../logActividad/logActividad.service";

declare var $: any;
declare var prettyPrint: any;
import myGlobals = require('../config');

var moment = require('moment');

@Component({
    selector: 'actividades',
    template: require('../../app/actividades/actividades.component.html'),
    styles: [require('../../app/actividades/actividades.component.css')]
})
export class ActividadesComponent implements OnInit {
    sucursales: Sucursal[];
    permisos: any;
    empresas: Empresa[];
    ubicaciones: Ubicacion[];
    sucursalSeleccionada: any;
    offsetTimeZone: string;
    nodos: Nodo[];
    regAlarma: RegAlarma[];
    regAlarmaNodos: RegAlarma[];
    socket: any;
    abierto: any;
    noData: any;
    fechaDesde: any;
    fechaHasta: any;
    mostrarEliminados: boolean;
    // idSensores: Array<any>;
    // idNodos: Array<any>;
    usuarioConectado: any;
    loading: boolean;
    jsondesc: string;
    func: any;


    constructor(private usuarioService: UsuariosService,
                private sucursalService: SucursalService,
                private empresaService: EmpresaService,
                private route: ActivatedRoute,
                private loginService: LoginService,
                private permisoService: PermisoService,
                private rolService: RolService,
                private regAlarmaService: RegAlarmaService,
                private nodoService: NodoService,
                private medicionService: MedicionService,
                private logActividadService: LogActividadService,
                private router: Router) {
        this.abierto = true;
        this.loginService.logIn.subscribe((mode) => {
            if (mode) {
                this.usuarioConectado = this.loginService.getDecodeToken();
            }
        });
    }


    ngOnInit() {
        window.scrollTo(0, 0);

        this.usuarioConectado = this.loginService.getDecodeToken();

        //Perdir permisos
        this.abierto = true;
        this.regAlarma = [];
        this.regAlarmaNodos = [];
        this.sucursalSeleccionada = "";
        this.mostrarEliminados = false;
        this.fechaDesde = new Date().toISOString().substring(0, 10);
        this.fechaHasta = new Date().toISOString().substring(0, 10);
        this.loading = false;
        this.offsetTimeZone = "-03:00";

        //Obtener empresas de ese usuario
        this.empresaService.getEmpresas()
            .subscribe(
                data => {
                    this.empresas = data;
                    if (data.length > 0)
                        this.cambiarSucursales(data[0]._id);
                });

        this.permisos = new Map();
        this.permisoService.getPermiso("alarma").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        });

        //Inicializar tabla
        $("#alertSeleccion").hide();

        //Ocultar la barra cuando hace click afuera
        if ($(window).width() < 769)
            $(document).bind("mouseup touchend", function (e) {
                var container = $("#barraSelectora");
                if (!container.is(e.target) // if the target of the click isn't the container...
                    && container.has(e.target).length === 0
                    && e.target.id != "iconoBarraSelectora" && e.target.className != "botonConfig" && e.target.id != "desBarraSelectora"
                    && e.target.id != "flechaBarraSelectora") // ... nor a descendant of the container
                {
                    $('#barraSelectora').css("display", "none");
                }
            });


    }

    ngOnDestroy() {
        let boton = document.getElementById("exportButton");
        if (boton)
            boton.removeEventListener("click", this.func);
    }

    cambiarSucursales(id) {
        $("#grid-dataNodo").bootgrid("destroy");
        $("#grid-data").bootgrid("destroy");
        this.sucursalService.getSucursalByEmpresa(id).subscribe((data) => {
            this.sucursales = data;

            if (data.length > 0) {
                //Calcular fechaDesde para mostrar histórico
                var fechaDesde = new Date();
                fechaDesde.setDate(fechaDesde.getDate() - data[0].historico_dias);
                this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
                //this.cambiarSensores(data[0]._id);
                this.cambiarFechaPorSucu(data[0]._id);
            } else {
                this.sucursales = [];
            }
        });
    }

    buscarRegistroActividad(e) {
        this.noData = false;
        //Alarmas Por Sensor
        $("#grid-data").on("initialized.rs.jquery.bootgrid", function () {
            $("#grid-data-header").find('.actions.btn-group').append('<button class="btn btn-default" id="exportButton" type="button" (click)="exportInformeActividades()">Exportar <span class="icon glyphicon glyphicon-export"></span></button>');
            let boton = <HTMLInputElement>document.getElementById("exportButton");
            this.func = this.exportInformeActividades.bind(this);
            if (boton) {
                boton.disabled = this.loading;
                boton.addEventListener("click", this.func);
            }
        }.bind(this)).bootgrid({
            ajax: true,
            selection: true,
            multiSelect: false,
            rowSelect: false,
            formatters: {
                "accion": function (column, row) {
                    switch (row.motivo) {
                        case "create":
                            return "<div><span class=\"label label-info\">Alta</span></div>"
                        case "update":
                            return "<div><span class=\"label label-warning\">Modificación</span></div>"
                        case "delete":
                            return "<div><span class=\"label label-danger\">Baja</span></div>"

                    }

                },
                "sucursal": function (column, row) {
                    return row.sucursal_id ? row.sucursal_id.descripcion : "-";

                },
                "fecha": function (column, row) {
                    var date_str = row.fecha;
                    if(moment(date_str).isValid())
                        return moment(date_str).utcOffset(this.offsetTimeZone).format("DD-MM-YYYY HH:mm");
                    else
                        return "";
                }.bind(this),
                "json": function (column, row) {
                    if (row.json) {
                        let j = row.json.split('\"').join(' ');
                        j = j.split(', ').join(', <br>');

                        return "<div id=\"accordion\" class=\"panel-group\"> " +
                            "<div class=\"panel panel-default\"> " +
                            "<div class=\"panel-heading\"> " +
                            "<h4 class=\"panel-title\"> " +
                            "<a onClick='$(\"#" + row._id + "\").collapse(\"toggle\")'>Ver datos</a> " +
                            "</h4> " +
                            "</div> " +
                            "<div id=\"" + row._id + "\" class=\"panel-collapse collapse\"> " +
                            "<div class=\"panel-body\"> " +
                            "<p style='overflow: scroll'><pre>" + JSON.stringify(j, null, 4) + "</pre></p>" +
                            "</div> " +
                            "</div> " +
                            "</div>" +
                            "</div>";
                    } else
                        return "";
                }
            },
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            },

            requestHandler: function (request) {
                //request.sensores = JSON.stringify({sensores_id: this.idSensores});

                request.idSucursal = this.sucursalSeleccionada._id;
                if (this.fechaDesde != null) {
                    var fechaDesdeStr = moment(this.fechaDesde).toISOString();
                    request.fechaDesde = fechaDesdeStr;
                }
                if (this.fechaHasta != null) {
                    var fechaHastaStr = moment(this.fechaHasta).endOf('day').toISOString();
                    request.fechaHasta = fechaHastaStr;
                }
                return request;
            }.bind(this),
            url: myGlobals.default.BASE_URL + "/logActividad/logActividadTable/"
        });
        $("#grid-data").bootgrid("reload");
    }

    cambiarFecha() {
        this.buscarRegistroActividad(null);
    }

    cambiarFechaPorSucu(id) {

        $("#grid-data").bootgrid("destroy");
        //Calcular fechaDesde
        var sucursalSeleccionada = null;
        for (let sucursal of this.sucursales) {
            if (sucursal._id == id) {
                sucursalSeleccionada = sucursal;
                this.sucursalSeleccionada = sucursal;
                if(sucursal && sucursal.husoHorario_id && sucursal.husoHorario_id.offset)
                    this.offsetTimeZone = sucursal.husoHorario_id.offset;
                else
                    this.offsetTimeZone = "-03:00";
                break;
            }
        }

        var fechaDesde = new Date();
        fechaDesde.setDate(fechaDesde.getDate() - sucursalSeleccionada.historico_dias);
        this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
        this.ubicaciones = [];

        this.cambiarFecha();

    }

    ocultarBarraSelectora() {
        if ($('#barraSelectora').css("display") == "block")
            $('#barraSelectora').css("display", "none");
        else
            $('#barraSelectora').css("display", "block");
    }

    exportInformeActividades() {
        let filtros = <any>{};
        let fechaDesdeStr = moment(this.fechaDesde).toISOString();
        filtros.fechaDesde = fechaDesdeStr;
        let fechaHastaStr = moment(this.fechaHasta).endOf('day').toISOString();
        filtros.fechaHasta = fechaHastaStr;
        filtros.idSucursal = this.sucursalSeleccionada._id;
        this.loading = true;
        let boton = <HTMLInputElement>document.getElementById("exportButton");
        if (boton)
            boton.disabled = this.loading;
        let inputs = document.getElementsByClassName("search-field form-control");
        if (inputs.length === 1)
            filtros.searchPhrase = (<HTMLInputElement>inputs[0]).value;
        this.logActividadService.export(filtros)
            .subscribe((res) => {
                this.loading = false;
                if (boton)
                    boton.disabled = this.loading;
            })
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/actividades/actividades.component.ts